export default __webpack_public_path__ + "static/media/bulb.ebedb524.svg";